<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-2">
                <div class="btn-group" role="group" aria-label="Like e dislike">
                    <button type="button" class="btn btn-sm btn-success mt-1" @click.prevent="updateLikes"><i class="far fa-thumbs-up"></i> {{formReact.likes}}</button>
                    <button type="button" class="btn btn-sm btn-danger mt-1" @click.prevent="updateDislikes"><i class="far fa-thumbs-down"></i> {{formReact.dislikes}}</button>
                </div>
            </div>
            <div class="col-md-10">
                <social-sharing :url="`https://${this.location}/externalBlog/${post.id}`"
                      :title="`${post.titulo}`"
                      :description="`${post.subtitulo}`"
                      :quote="`${post.subtitulo}`"
                      :hashtags="`${post.tagsRefinadas}`"
                      :media="(post.tipoatracao == 2)?'https://'+this.location+'/images/blog/posts/'+post.atracao:'https://'+this.location+'/images/logo.png'"
                      inline-template>
                    <div>
                        <network network="email" class="share btn btn-sm btn-secondary mt-1">
                            <i class="fa fa-envelope"></i> Email
                        </network>
                        <network network="facebook" class="share btn btn-sm mt-1" style="background-color: #3b5998; color: white">
                            <i class="fab fa-facebook-f"></i> Facebook
                        </network>
                        <network network="linkedin" class="share btn btn-sm mt-1" style="background-color: #0e76a8; color: white">
                            <i class="fab fa-linkedin-in"></i> LinkedIn
                        </network>
                        <network network="pinterest" class="share btn btn-sm mt-1" style="background-color: #c8232c; color: white">
                            <i class="fab fa-pinterest"></i> Pinterest
                        </network>
                        <network network="reddit" class="share btn btn-sm mt-1" style="background-color: #ff4500; color: white">
                            <i class="fab fa-reddit-alien"></i> Reddit
                        </network>
                        <network network="skype" class="share btn btn-sm mt-1" style="background-color: #00aff0; color: white">
                            <i class="fab fa-skype"></i> Skype
                        </network>
                        <network network="sms" class="share btn btn-sm mt-1">
                            <i class="far fa-paper-plane"></i> SMS
                        </network>
                        <network network="telegram" class="share btn btn-sm mt-1" style="background-color: #0088cc; color: white">
                            <i class="fab fa-telegram-plane"></i> Telegram
                        </network>
                        <network network="twitter" class="share btn btn-sm mt-1" style="background-color: #00acee; color: white">
                            <i class="fab fa-twitter"></i> Twitter
                        </network>
                        <network network="whatsapp" class="share btn btn-sm mt-1" style="background-color: #25d366; color: white">
                            <i class="fab fa-whatsapp"></i> Whatsapp
                        </network>
                    </div>
                </social-sharing>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                location: window.location.host,
                formReact: '',
            }
        },
        props:{
            post:{
                required: true
            }
        },
        methods: {
            getData(){
                axios.get('/api/getReactions/'+this.post.id)
                    .then(({data}) => {
                        this.formReact = new vForm(data);
                    });
                Fire.$emit('update-views');
                //this.updateViews();
            },
            updateLikes(){
                this.$Progress.start();
                this.formReact.post('https://'+this.location+'/api/likePostagem')
                    .then(({data})=>{
                        toast.fire({
                            icon: 'success',
                            title: 'Reação salva com sucesso.'
                        });
                        this.formReact.fill(data);
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        toast.fire({
                            icon: 'error',
                            title: 'Reação não salva. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
            updateDislikes(){
                this.$Progress.start();
                this.formReact.post('https://'+this.location+'/api/dislikePostagem')
                    .then(({data})=>{
                        toast.fire({
                            icon: 'success',
                            title: 'Reação salva com sucesso.'
                        });
                        this.formReact.fill(data);
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        toast.fire({
                            icon: 'error',
                            title: 'Reação não salva. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
            updateShares(){
                this.$Progress.start();
                this.formReact.post('https://'+this.location+'/api/sharePostagem')
                    .then(({data})=>{
                        toast.fire({
                            icon: 'success',
                            title: 'Reação salva com sucesso.'
                        });
                        this.formReact.fill(data);
                        this.$Progress.finish();
                    })
                    .catch(()=>{
                        toast.fire({
                            icon: 'error',
                            title: 'Reação não salva. Algo aconteceu...'
                        });
                        this.$Progress.fail();
                    });
            },
            updateViews(){
                this.formReact.post('https://'+this.location+'/api/viewPostagem')
                    .then(({data})=>{
                        this.formReact.fill(data);
                    })
                    .catch(()=>{
                    });
            },

        },
        mounted(){
            $(".share").on('click', () => {
                this.updateShares();
            });
            Fire.$on('update-views', () => {
                setTimeout(() => { this.updateViews() }, 2000);
            });
        },
        watch: {
            post: function(){
                this.getData();
            }
        }
    }
</script>
